module.exports = __webpack_public_path__ + "media/18.0fa92141.mp3";